import { createRouter, createWebHistory } from 'vue-router'
import UAParser from "ua-parser-js";

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/HomeView.vue'),
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/article/Article.vue'),
  },
  {
    path: '/use-cases',
    name: 'articles',
    component: () => import('@/views/article-list/ArticleList.vue'),
  },
  {
    path: '/pdf-to-word',
    name: 'pdf2word',
    component: () => import('@/views/pdf2word/Pdf2Word.vue'),
  },
  {
    path: '/ocr-text-extraction',
    name: 'ocr2word',
    component: () => import('@/views/ocr2word/Ocr2Word.vue'),
  },
  {
    path: '/table-format-conversion',
    name: 'table2word',
    component: () => import('@/views/table2word/Table2Word.vue'),
  },
  {
    path: '/faq',
    name: 'qa',
    component: () => import('@/views/q&a/Q&A.vue'),
  },
  {
    path: '/price',
    name: 'price',
    component: () => import('@/views/price/Price.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/privacy/Privacy.vue'),
  },
  {
    path: '/convert-scans-to-editable-docs',
    name: 'detail_choose',
    component: () => import('@/views/detail_choose_text/DetailChooseText.vue')
  }
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

//申明全局的导航守卫
// to：目标路由对象 from：当前导航正要离开的路由对象 next：是一个函数，表示放行
router.beforeEach(async (to, from, next) => {
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name ="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  const parser = new UAParser();
  const result = parser.getResult();
  if (result.os.name === 'Android' || result.os.name === 'iOS' || result.os.name === 'BlackBerry' || result.os.name === 'Windows Phone') {
    next();
  } else {
    const paths = ['/home', '/detail', '/use-cases', '/faq', '/price', '/privacy', '/convert-scans-to-editable-docs']
    if (paths.includes(to.path)) {
      window.location.href = 'https://scan2word.com';
    } else {
      window.location.href = 'https://scan2word.com' + to.path;
    }
  }
})

export default router
